import React from 'react'
import AchievementsCenterHeader from '../../assets/images/achievements/AchievementsCenterHeader.png'
import ProgressBar from '../ProgressBar'
import { ReactComponent as QuestionMark } from '../../svg/achievements/QuestionMark.svg'
import { useUser } from '../../context/user'
import { useTranslation } from 'react-i18next'

function AchievementsHeader() {
    const { availablePoints } = useUser()
    const { t } = useTranslation()
    return (
        <div className="achievements-center-header" style={{ backgroundImage: `url(${AchievementsCenterHeader})` }}>
            <div className="achievements-center-header-content">
                <div className="achievements-center-header-content-title">{t('Achievements center')}</div>
                <div className="achievements-center-header-content-subtitle">{t('Earn points by completing tasks and exchange them into rewards')}</div>
                <div className="achievements-center-progressbar">
                    <ProgressBar completed={35} backgroundColor="#153c4f" />
                    {/* <div className='achievements-center-progressbar-text'>
						{t('10 more points possible to earn today')}
					</div> */}
                </div>
                <div className="achievements-center-header-info">
                    <QuestionMark />
                    <div className="achievements-center-header-info-text">{t('Check points system')}</div>
                </div>
            </div>
            <div className="achievements-header-available-points">
                <div className="achievements-header-available-points-number">{availablePoints}</div>
                <div className="achievements-header-available-points-text">{t('Available points')}</div>
            </div>
        </div>
    )
}

export default AchievementsHeader
